import { render, staticRenderFns } from "./NoteCard.vue?vue&type=template&id=ec8f90f4&scoped=true&"
import script from "./NoteCard.vue?vue&type=script&lang=js&"
export * from "./NoteCard.vue?vue&type=script&lang=js&"
import style0 from "./NoteCard.vue?vue&type=style&index=0&id=ec8f90f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8f90f4",
  null
  
)

export default component.exports